import { Box } from "@mui/material";
import { styles } from "./style";

export default function TermsContent() {
  return (
    <Box sx={styles.container}>
      <pre style={styles.text}>
        この利用規約（以下「本利用規約」といいます。）は、株式会社モンドミックス・ジャパン（以下「当社」といいます。）が提供する食品製造設備（以下「本設備」といいます。）の Cloud サービス「Mondomixer IoT Cloud」（以下「本サービス」といいます。）の利用に関する条件を定めるものです。本利用規約は、本サービスを利用するすべての方に適用されます。本サービスをご利用になる前に、本利用規約の内容をよくお読みください。本利用規約に同意されない場合は、本サービスを利用することはできません。
        <br />
        <br />
        第1条 （目的）
        <br />
        1.
        本利用規約は、本サービスの利用に関する条件及び当社とお客様との間の権利義務関係を定めることを目的としています。
        <br />
        2.
        お客様は、本サービスを利用するにあたり、本利用規約を遵守するものとします。
        <br />
        <br />
        第2条 （本サービスの内容）
        <br />
        本サービスは、本設備の稼働状況を当社がリモートモニタリングすることにより、トラブル発生時に迅速に原因の発見及び特定を行うことにより、お客様の本設備ダウンタイムの短縮に資することを目的としたサービスとなります。
        <br />
        <br />
        第3条 （本サービスの申込）
        <br />
        1.
        本サービスの利用を希望するお客様は、本利用規約を遵守することに同意し、かつ当社の定める情報（以下「登録情報」といいます。）を当社指定の方法で当社に提供することにより、登録を申請することができます。
        <br />
        2.
        当社がお客様からの申請受領後、当該申請を承諾した時点で本利用規約に基づく本サービスの利用契約（以下「本利用契約」といいます。）が成立するものとし、当社は、本利用契約の成立後、本サービス稼働のために必要な機器を、お客様と別途協議の上合意する日時において、本設備に設置します。
        <br />
        3.
        当社が前項の機器稼働確認を実施した日より本サービスの利用が開始するものとします。
        <br />
        4.
        お客様が以下の各号のいずれかに該当し又は該当するおそれがあると当社が判断した場合には、登録を拒否することができます。なお、登録申請が承認されなかったとしても、当社はその理由を開示する義務を負いません。
        <br />
        (1) 当社に提供された登録情報の全部又は一部につき虚偽、誤記又は記入漏れがある場合
        <br />
        (2) 反社会的勢力等に所属し若しくは過去に所属していた場合、その他反社会的勢力等となんらかの交流若しくは関与等がある場合
        <br />
        (3) 過去に、本サービスその他当社のサービスの利用登録の拒否若しくは取消等の措置を受けた場合
        <br />
        (4) その他当社が登録を不適当と認める場合
        <br />
        5.
        本利用契約の有効期間中にお客様が前項の各号のいずれかに該当した場合、当該お客様はただちに当社に通知しなければならないものとします。
        <br />
        <br />
        第4条 （アカウント） <br />
        1.
        お客様は、ID、パスワードその他お客様のアカウントに関する情報を、自己の責任において安全に管理・保管し、第三者による不正使用を防止するために必要な措置を講じるものとします。
        <br />
        2. 
        お客様は、自己のアカウント又は ID、パスワードを第三者に貸与、共有、譲渡、名義変更その他の方法により第三者に使用させてはなりません。
        <br />
        3. 
        当社は、ID とパスワードの一致を確認した場合、当該 ID 及びパスワードの保有者として登録されたお客様が本サービスを利用したものとみなします。
        <br />
        4.
        お客様は、本サービスのアカウントの不正利用若しくは第三者による使用又はそれらのおそれが判明した場合には、ただちにその旨を当社に通知するとともに、当社からの指示に従うものとします。
        <br />
        <br />
        第5条 （サポートサービス） <br />
        1.
        お客様は本設備に不具合が生じた際、別途当社よりお伝えするエンジニア窓口へ問い合わせることができます。なお、窓口対応時間は当社休業日を除く平日９時から１７時３０分となります。
        <br />
        2.
        当該不具合がリモートで解消できた際、サポート対応費用は無償としますが、オンサイトでの対応が必要となった場合は有償となります。なお、その際の対応費用は別途当社より見積もりを提出します。
        <br />
        <br />
        第6条 （利用料金） <br />
        1.
        お客様は当社に対し、別途取り決める年間利用料金を指定の方法により支払うものとします。
        <br />
        2.
        お客様が、前項に定める利用料金の支払を遅滞した場合、年３％の割合による遅延損害金を当社に支払うものとします。
        <br />
        <br />
        第7条 （禁止事項）
        <br />
        お客様は、本サービスの利用に関して、自己又は第三者をして、以下の各号の行為を行わないものとします。
        <br />
        (1) 本利用規約に違反する行為 <br />
        (2) 法令等に違反する行為 <br />
        (3) 犯罪行為又は犯罪を助長する行為 <br />
        (4) 当社又は第三者に対する詐欺又は脅迫行為 <br />
        (5) 公序良俗に反する行為 <br />
        (6) 反社会的勢力等に対する利益供与その他反社会的勢力等に関与する行為 <br />
        (7) 当社又は第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害する行為 <br />
        (8) 当社又は第三者を誹謗中傷する行為 <br />
        (9) 虚偽の登録情報を提供する行為 <br />
        (10) 第三者に成りすます行為 <br />
        (11) 本サービスの一部を複製、頒布又は不正に開示する行為 <br />
        (12) 当社のネットワーク又はシステム等に過度な負荷をかける行為 <br />
        (13) 当社のネットワーク又はシステム等へ不正にアクセスする行為又はそれを試みる行為 <br />
        (14) 本サービス又は当社サイトに関連するプログラムを変更、削除、逆コンパイル、逆アセンブル又はリバースエンジニアリングする行為<br />
        (15) 本サービスの運営を妨害する行為 <br />
        (16) 当社の信用を毀損し又はそのおそれのある行為 <br />
        (17) 当社又は第三者に損害等を与える行為 <br />
        (18) その他当社が不適当と認める場合 <br />
        <br />
        第8条 （非保証） <br />
        1.
        本サービスは、提供される情報の正確性及び完全性を保証するものではありません。
        <br />
        2.
        当社は、本サービスの利用により生じた直接的又は間接的な損害について、当社に故意又は重過失がある場合を除き、一切の責任を負いません。
        <br />
        <br />
        第9条 （データの利用）
        <br />
        当社は、本サービスを通じて取得するデータ（ただし、個人情報に該当するものを除きます。）を、本サービスを含む当社が提供し又は提供しようとしているサービスの品質向上、これらのサービスに関するお客様へのご案内等の目的で利用することができるものとします。
        <br />
        <br />
        第10条 （利用停止及び解約） <br />
        1.
        お客様が以下の各号のいずれかの事由に該当すると当社が判断した場合、当社は事前に通
        知することなく、当該お客様による本サービスへのアクセスを禁止し、又は当該お客様が本サ
        ービスに関して当社に提供した情報の全部若しくは一部を削除することができるものとします
        （以下、総称して「利用停止」といいます。）。
        <br />
        (1) 本利用規約のいずれかの条項に違反した場合 <br />
        (2) 第３条第４項各号の登録拒否事由のいずれかに該当した場合 <br />
        (3) 利用料金その他本利用契約に基づく支払を期日に行わず、当社の催促から５営業日以内に支払遅延が解消されない場合 <br />
        (4) 前各号に準ずる事態が生じた場合 <br />
        (5) その他本サービスの利用又は登録が不適当である場合 <br />
        2.
        お客様が以下の各号のいずれかの事由に該当する場合、当社はお客様に通知の上、ただちに本利用契約を解約することができます。
        <br />
        (1) 前項各号のいずれかに該当した場合 <br />
        (2) お客様が支払停止又は支払不能となった場合 <br />
        (3) お客様について破産、民事再生、会社更生、特別清算、又はこれらに類する手続の開始の申立てがあった場合 <br />
        (4) お客様について解散又は清算の手続開始が決議又は決定された場合 <br />
        (5) 当社がお客様の本サービスの利用、登録又は本利用契約の継続を適当でないと判断した場合 <br />
        3.
        前二項に定める措置は、当社から当該お客様に対する損害賠償請求を行うことを妨げるものではありません。また、前二項に定める措置を行ったことについて、当社は一切の損害賠償義務、金銭返還義務を負いません。
        <br />
        <br />
        第11条 （お客様による解約） <br />
        1. 
        お客様が期間満了日の１か月前までに当社の定める本サービスの解約手続を行った場合、本サービスの利用期間の満了により契約終了の効力が生じ、お客様は、本サービスを利用できなくなるものとします。
        <br />
        2.
        お客様は、本利用契約が終了した場合であっても、当社及び第三者に対して既に生じた本利用契約上の一切の義務及び債務（損害賠償義務を含みますが、これに限りません。）を免れるものではありません。
        <br />
        <br />
        第12条 （本サービスの停止） <br />
        1.
        当社は以下のいずれかに該当する場合には、お客様に事前に通知することにより、本サービスの全部又は一部の提供を停止できるものとします。
        <br />
        (1) 本サービスに関わるハードウェア、ソフトウェア、通信機器その他関連する機器若しくはシステムの点検又は保守作業を定期的に又は緊急に行う場合 <br />
        (2) コンピューター若しくは通信回線等の障害、誤操作、過度なアクセスの集中、不正アクセス、ハッキング、その他予期せぬ要因により本サービスの提供が困難となった場合 <br />
        (3) 本サービスに関するセキュリティ上の問題が生じた場合 <br />
        (4) 天災地変、戦争、戦争のおそれ、封鎖、通商停止、革命、暴動、伝染病若しくはその他の疫病、物資若しくは施設の破壊若しくは損傷、火災、台風、地震、洪水、その他当社の支配を超える事由 <br />
        (5) 法令等又はこれらに基づく措置により本サービスの運営が困難となった場合 <br />
        (6) その他前各号に準じる事由により当社が必要と判断した場合 <br />
        2.
        前項により当社が行った措置によって生じた損害について、一切の責任を負いません。
        <br />
        <br />
        第13条 （本サービスの変更・追加） <br />
        1.
        当社は、当社の都合により、本サービスの性質に重大な変更が生じない範囲で本サービスの内容の変更又は追加ができるものとします。
        <br />
        2.
        前項により当社が行った措置によって生じた損害について、一切の責任を負いません。
        <br />
        <br />
        第14条 （本サービスの終了） <br />
        1.
        当社は、お客様へ事前に通知することにより、本サービスの全部又は一部の提供を終了できるものとします。
        <br />
        2. 
        本サービスの全部を終了する場合、当社はお客様に対して終了予定日の１か月前までに通知を行うものとします。ただし、緊急の場合その他事前の通知が困難な場合には、事後に通知するものとします。
        <br />
        3. 
        第１項及び第２項により当社が行った措置によって生じた損害について、一切の責任を負いません。
        <br />
        <br />
        第15条 （契約終了後の措置） <br />
        1.
        本利用契約が終了した場合、当社はお客様の本サービスの利用を停止します。
        <br />
        2.
        当社は、本利用契約終了日より１か月以内を目安に、お客様と協議した日時において、第３条第２項に定める機器を本設備より取り外し回収するものとします。
        <br />
        3.
        当社は、本利用契約の終了後にお客様に通知することなく、お客様に関連するユーザーコンテンツを含むすべての情報を削除することができます。
        <br />
        4. 
        本利用契約終了時に本利用契約に基づく未履行の債務がある場合は、当該債務には履行が完了するまで本利用規約が適用されます。
        <br />
        <br />
        第16条 （損害賠償） <br />
        1.
        お客様による本利用規約に違反する行為又は本サービスに関連してお客様の責めに帰すべき事由により当社又は第三者に損害が生じたときは、お客様はその一切の損害につき賠償する義務を負うものとします。
        <br />
        2.
        当社の故意又は重過失によりお客様又はに損害（現実に生じた直接かつ通常の損害に限る。）が生じた場合の当社の責任賠償額の総額は、本サービス利用料の１年分に相当する金額を上限とします。
        <br />
        <br />
        第17条 （秘密保持義務） <br />
        1.
        当社及びお客様は、本利用契約に関連して双方が開示する営業上又は技術上その他一切の情報のうち、相手方に対して秘密である旨明示して開示した情報及び性質等に鑑みて通常秘密情報として取扱われるべき情報（以下「秘密情報」といいます。）を厳重に保管・管理するものとします。ただし、次の各号の一に該当する情報については秘密情報に含まれません。
        <br />
        (1) 開示を受ける前に公知であったもの <br />
        (2) 開示を受けた後に自己の責に帰すべき事由によることなく公知となったもの <br />
        (3) 開示を受ける前に既に自ら保有していたもの <br />
        (4) 正当な権限を有する第三者から秘密保持義務を負わずに入手したもの <br />
        (5) 開示を受けた情報によることなく独自に開発したもの <br />
        2.
        当社及びお客様は、相手方の事前の書面による承諾なく、秘密情報を第三者に開示、漏えいしてはなりません。ただし、法令により開示義務を負うとき又は法律上権限ある官公署により開示を命じられたときは、必要な範囲内に限り、開示することができるものとします。この場合、当社及びお客様は、事前に相手方に通知しなければなりません。
        <br />
        3.
        当社及びお客様は、秘密情報について、本利用契約の目的の範囲でのみ使用するものとし、本利用契約の目的の範囲を超える複製、改変が必要なときは、事前に相手方から書面による承諾を得なければなりません。
        <br />
        4.
        当社及びお客様は、本利用契約が終了したとき又は相手方から要求があったときは、協議の上定めた方法に従い、秘密情報（その複製物を含む。）の返還又は破棄その他の措置を講ずるものとします。
        <br />
        <br />
        第18条 （個人情報の取扱い）
        <br />
        当社は、本サービスの提供に関連して得た個人情報を、当社の個人情報保護方針に従った当社プライバシーポリシー（https://mondomix-japan.co.jp/privacy-policy/）に従って取扱います。お客様は、当社がこのプライバシーポリシーに従って個人情報を取り扱うことに同意するものとします。
        <br />
        <br />
        第19条 （本利用規約の変更） <br />
        1.
        当社は、以下の各号のいずれかに該当する場合、本利用規約を変更することができるものとします。
        <br />
        (1) 本利用規約の変更が、お客様の一般の利益に適合するとき <br />
        (2) 本利用規約の変更が、契約をした目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容その他の変更にかかる事情に照らして合理的なものであるとき <br />
        2.
        前項の場合、当社は、変更後の本利用規約の効力発生日の１か月前までに、本利用規約を変更する旨及び変更後の本利用規約の内容とその効力発生日を、当社が適切と判断する方法（当社サイト・本サービス内への掲示又はお客様に電子メールを送信する方法等）により通知します。
        <br />
        3.
        本利用規約の変更に同意しないお客様は、前項に定める変更の効力発生日の前日までに、本利用契約を解約するものとします。効力発生日までに本利用契約の解約を行わず、本サービスの利用を継続した場合には、当該変更に同意したものとみなします。
        <br />
        4.
        第一項に定める他、当社は、お客様の同意を得ることにより本利用規約を変更することができるものとします。
        <br />
        <br />
        第20条 （有効期間） <br />
        1. 
        本利用契約の有効期間は、第３条第３項に定める利用開始日から１年間とします。
        <br />
        2.
        当社は、お客様に対し、本利用契約満了日の２か月前までに、本利用契約について、次年度の利用料金の見積もりの提出及び本利用契約更新の意思確認を行います。
        <br />
        3.
        お客様が前項の意思確認の１か月前までになんら意思表示をしない場合又は本利用契約の更新をしないという意思を表示した場合、本利用契約は契約満了日をもって終了するものとします。
        <br />
        <br />
        第21条 （権利義務の譲渡禁止）
        <br />
        お客様は、当社の事前の書面による承諾なく、本利用契約上の地位又は本利用契約に基づく権利若しくは義務を、第三者に譲渡、移転（合併若しくは会社分割による場合を含みます。）、担保設定又はその他の処分をしてはなりません。
        <br />
        <br />
        第22条 （分離可能性）
        <br />
        本利用規約のいずれかの条項又はその一部が、法令等により無効又は執行不能と判断された場合であっても、本利用規約の残りの規定又は部分は、継続して完全に効力を有するものとし、当社とお客様は、当該無効若しくは執行不能の条項又は部分を適法とし、執行力をもたせるために必要な範囲で修正し、当該無効若しくは執行不能な条項又は部分の趣旨並びに法律的及び経済的に同等の効果を確保できるように努めるものとします。
        <br />
        <br />
        第23条 （存続条項）
        <br />
        第９条（データの利用）、第１６条（損害賠償）、第１７条（秘密保持義務）、第１８条（個人情報の取扱い）、本条及び条項の性質に鑑み当然に存続すべき規定は、期間満了、解除、失効、その他理由の如何を問わず、本利用契約が終了した後も引き続きその効力を有します。
        <br />
        <br />
        第24条 （協議）
        <br />
        本利用規約の解釈に疑義が生じた場合、又は本利用規約に定めのない事項については、当社とお客様は、誠意をもって協議の上これを解決するものとします。
        <br />
        <br />
        第25条 （管轄裁判地）
        <br />
        本利用契約に関する紛争については、訴額に応じ大阪地方裁判所又は大阪簡易裁判所を第一審の専属的合意管轄裁判所とします。なお、調停を行う場合についても同様とします。
        <br />
        <br />
        <br />
        制定日 2025 年 2 月 17 日
      </pre>
    </Box>
  );
}
